import { neverHere } from "../tsHelpers";

export const toString = (status: PaymentStatus) => {
  switch (status) {
    case PaymentStatus.Pending:
      return "Pending";
    case PaymentStatus.Failed:
      return "Failed";
    case PaymentStatus.Done:
      return "Done";
    default:
      return neverHere(status);
  }
};

export const toClassName = (status: PaymentStatus) => `payment-${toString(status).toLowerCase()}`;
